import { useMutation, useQueryClient } from 'react-query';

import { IntegrationType } from 'src/generated/mloop-graphql';

import { putIntegration } from './integrationPut';
import { QUERY_KEY } from './types';

const INTEGRATION_TYPE: IntegrationType = IntegrationType.HackerrankApiKey;

// eslint-disable-next-line @typescript-eslint/ban-types
function putHackerRankIntegration(apiKey: string): Promise<{}> {
  return putIntegration({
    integration_type: INTEGRATION_TYPE,
    hackerrank: {
      api_key: apiKey,
    },
  });
}

export default function useHackerRankIntegrationPut() {
  const queryClient = useQueryClient();
  return useMutation((apiKey: string) => putHackerRankIntegration(apiKey), {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEY);
      queryClient.invalidateQueries([QUERY_KEY, INTEGRATION_TYPE]);
    },
  });
}
